<div class="page-header-container">
    <div class="page-title">
        {{'invoice.title' | translate}}
        <div class="subtitle-txt text-main fw-medium">
            {{'invoice.subtitle' | translate}}:
            <span HJSuppress class="subtitle-value-txt fw-bold text-primary">{{client?.uniqueIdentifier}}</span>
            <button class="btn copy-clipboard-btn ms-2" [cdkCopyToClipboard]="client?.uniqueIdentifier" (click)="showClipboardNotification()">
                <i class="app-icon icon icon-copy icon-md2"></i>
            </button>
        </div>
    </div>
</div>

<div *ngIf="hasData" class="header-buttons-box">
    <button class="btn m-outline-btn"
        (click)="downloadInvoices()" [disabled]="loading"
    >
        <i class="app-icon icon icon-file-excel icon-lg"></i>
        {{'invoice.exportAs' | translate}} {{'invoice.Xls' | translate}}
    </button>
</div>

<div class="page-header-container align-items-lg-end mb-4">
    <div class="d-flex">
        <button *ngIf="showArrows" class="btn arrow-btn" (click)="prevSlide()" 
            [disabled]="currentIndex === 0">
            <i class="app-icon icon icon-chevron-left icon-lg text-secondary"></i>
        </button>
        <div class="d-flex gap-3">
          <div class="total-card d-flex flex-column gap-2" *ngFor="let paymentDetail of displayedTotalInvoices">
            <div class="fw-semibold fs-5 text-secondary">
                {{'invoice.totalCard.title' | translate}} {{ paymentDetail.currencyCode }}
            </div>
            <div class="d-flex gap-4">
              <div class="d-flex flex-column">
                <span class="total-label fw-semibold text-secondary">{{'invoice.totalCard.totalInvoiced' | translate}}</span>
                <span HJSuppress class="fs-5 fw-bold">{{ paymentDetail.totalInvoiced | number: '1.' }} {{ paymentDetail.currencyCode }}</span>
              </div>
              <div class="d-flex flex-column">
                <span class="total-label fw-semibold text-secondary">{{'invoice.totalCard.totalUnpaid' | translate}}</span>
                <span HJSuppress class="fs-5 fw-bold">{{ paymentDetail.totalUnpaid| number: '1.' }} {{ paymentDetail.currencyCode }}</span>
              </div>
            </div>
          </div>
        </div>
        <button *ngIf="showArrows" class="btn arrow-btn" (click)="nextSlide()" 
            [disabled]="currentIndex === totalInvoices.length - this.visibleCardCount">
            <i class="app-icon icon icon-chevron-right icon-lg text-secondary"></i>
        </button>
    </div>

    <div class="header-buttons-box">
        <button *ngIf="contractFilterCount <= 0" class="btn white-btn text-uppercase" (click)="contractHandler()">
            {{'invoice.contractFilter' | translate}}
        </button>
        
        <div class="buttons-group-box active-filters-reset" *ngIf="contractFilterCount > 0">
            <div class="btn-group" role="group">
                <button class="btn white-btn text-uppercase" (click)="contractHandler()">
                    <span>{{'invoice.contractFilterActive' | translate}}</span>
                </button>
                <button class="btn white-btn" (click)="resetFiltersHandler(FILTERS_RESET_TYPE.OTHER_FILTERS)">
                    <span class="active-filters-badge">{{contractFilterCount}}</span>
                    <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
                </button>
            </div>
        </div>

        <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
            {{'invoice.filter' | translate}}
        </button>
        
        <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
            <div class="btn-group" role="group">
                <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                    <span>{{'invoice.filterActive' | translate}}</span>
                </button>
                <button class="btn white-btn" (click)="resetFiltersHandler(FILTERS_RESET_TYPE.ACTIVE_FILTERS)">
                    <span class="active-filters-badge">{{activeFilterCount}}</span>
                    <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
                </button>
            </div>
        </div>

        <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
            <div class="btn-group" role="group">
                <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
                    [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                    <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                    <span>{{'common.listView' | translate }}</span>
                </button>
                <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
                    [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                    <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                    <span>{{'common.cardsView' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<invoice-list-view 
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp) && hasData && hasFilterData"
    [invoices]="invoices" 
    [props]="props" 
    [navigateToDetailHandler]="navigateToDetailHandler"
></invoice-list-view>
<invoice-card-view 
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp) && hasData && hasFilterData"
    [invoices]="invoices" 
    [props]="props" 
    [navigateToDetailHandler]="navigateToDetailHandler"
></invoice-card-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>